import { ArrowUpDown, ArrowUp, ArrowDown } from "lucide-react";
import { TableHead } from "@/components/ui/table";

export function scoreBadge(score) {
  if (score >= 95) return "text-green-700 border-green-300 bg-green-50";
  if (score >= 80) return "text-amber-700 border-amber-300 bg-amber-50";
  return "text-slate-600 border-slate-200 bg-slate-50";
}

export const KIND_LABELS = { gasto_directo: "Gasto sin factura", venta_loyverse: "Venta Loyverse", liquidacion_tarjeta: "Liquidación tarjeta", otro_ingreso: "Otro ingreso" };

const MONTH_NAMES = ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];
export const monthLabel = (ym) => { const [y, m] = ym.split("-"); return `${MONTH_NAMES[Number(m) - 1]} ${y}`; };

export function SortableHead({ label, sortKey, defDir = "asc", sort, clickSort, testid, right = false }) {
  const icon = sort.key !== sortKey ? <ArrowUpDown className="w-3.5 h-3.5 text-slate-300" />
    : sort.dir === "asc" ? <ArrowUp className="w-3.5 h-3.5" /> : <ArrowDown className="w-3.5 h-3.5" />;
  return (
    <TableHead className={`cursor-pointer select-none ${right ? "text-right" : ""}`} data-testid={testid}
      onClick={() => clickSort(sortKey, defDir)}>
      <span className={`inline-flex items-center gap-1 ${right ? "justify-end" : ""}`}>{label} {icon}</span>
    </TableHead>
  );
}
